import { observable, action, makeObservable } from "mobx";
import { IStatusDataResponse } from "../pages/StatusTable/interfaces/IStatusData";
import { NotificationsStore } from "./NotificationsStore";
import { NotificationType } from "../interfaces/template/INotification";
import { WomApiService } from "../services/data-services/WomApiService";
import { BaseStoreClass } from "./BaseStoreClass";
import { getErrorMessage } from "utilities/ErrorHelper";

export enum FilterFields {
  Heartbeat = "heartbeat",
  Name = "search",
  Severity = "severity",
}

export class StatusStore extends BaseStoreClass {
  private womApiService: WomApiService;
  private notificationStore: NotificationsStore;

  status: IStatusDataResponse | undefined = undefined;

  sortOrderBy: string = "";
  sortType: boolean = true;

  constructor(
    womApiService: WomApiService,
    notificationStore: NotificationsStore
  ) {
    super();
    this.womApiService = womApiService;
    this.notificationStore = notificationStore;

    makeObservable(this, {
      status: observable,
      sortOrderBy: observable,
      sortType: observable,
      //
      setStatus: action,
      fetchStatus: action,
      setSortOrderBy: action,
    });
  }

  fetchStatus = async ({
    pageNumber,
    take,
  }: {
    pageNumber: number;
    take: number;
  }) => {
    this.isLoading = true;
    this.page = pageNumber;
    this.take = take;

    const sortParams = this.sortOrderBy
      ? `&sortBy=${this.sortOrderBy}&sortAcc=${this.sortType}`
      : "";

    try {
      const response = await this.womApiService.getStatus(
        `${this.filtersQueryStr(this.filters)}${sortParams}`,
        (this.page - 1) * this.take,
        this.take
      );

      if (response) {
        this.setStatus(response);
        this.isLoading = false;
      }
    } catch (ex) {
      this.notificationStore.addToast(
        NotificationType.success,
        getErrorMessage(ex),
        NotificationType.success
      );
    }
  };

  // ==============================

  setStatus = (data: IStatusDataResponse) => {
    this.status = data;
    this.totalItemCount = data.totalSearchAmount;
  };

  setSortOrderBy = (field: string) => {
    if (this.sortOrderBy === field) {
      if (this.sortType) {
        // If it's currently ascending, set to descending
        this.sortType = false;
      } else {
        // If it's currently descending, remove sorting
        this.sortOrderBy = "";
        this.sortType = true; // Reset to default
      }
      return;
    }
    // If the clicked field is different, set to ascending
    this.sortOrderBy = field;
    this.sortType = true;
  };
}
